// Client/src/services/AdminSystemService.ts
import { SocketClient, SocketAuthErrorEvent } from './SocketClient';

interface AdminCommand {
  commandId: string;
  commandType: string;
  timestamp: string;
  data?: unknown;
}

class AdminSystemService {
  private socketClient: SocketClient;

  constructor() {
    this.socketClient = new SocketClient();
  }

  async connect(employeeId?: string): Promise<boolean> {
    return this.socketClient.connect({
      employeeId,
      connectionType: 'admin'
    });
  }

  onCommand(callback: (command: AdminCommand) => void): void {
    this.socketClient.on('admin_command_from_server', callback);
  }

  offCommand(callback?: (command: AdminCommand) => void): void {
    this.socketClient.off('admin_command_from_server', callback);
  }

  sendCommandResult(result: {
    commandId: string;
    commandType: string;
    timestamp: string;
    success: boolean;
    result?: string;
    error?: string;
  }): void {
    this.socketClient.send('admin_command_result', result);
  }

  isConnected(): boolean {
    return this.socketClient.isConnected &&
           (this.socketClient.currentConnectionType === 'admin' || this.socketClient.currentConnectionType === 'main');
  }

  disconnect(): void {
    this.socketClient.disconnect();
  }

  onAuthError(callback: (event: SocketAuthErrorEvent) => void): void {
    this.socketClient.on('auth_error', callback);
  }

  offAuthError(callback?: (event: SocketAuthErrorEvent) => void): void {
    this.socketClient.off('auth_error', callback);
  }
}

// Singleton-Instanz
const adminSystemService = new AdminSystemService();
export default adminSystemService;
export { AdminSystemService };
